
import '../App.css';
import React, { useState, useEffect, useRef } from 'react';


import { useNavigate } from 'react-router-dom';
import { auth, db } from '../config';
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import moment from 'moment/moment';
import { FaRegEye, FaRegEyeSlash, FaUserFriends } from "react-icons/fa";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { add_icon, delete_icon } from '../assets/Icons';
import { IoIosCloseCircle } from "react-icons/io";
import { decrypt, encrypt } from '../Crypto';
import { Button, Typography } from '@mui/material';
import { connect } from 'react-redux';
import { SetId } from './redux/actions';
import Collapsible from 'react-collapsible';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

const userdb = db.ref('userdb');

const devices_db = db.ref('devices');
const customerdb = db.ref('customerdb');

const height = window.innerHeight;
const width = window.innerWidth;
console.log(height)
console.log(width)


function Forget({ items, SetId }) {


    const navigate = useNavigate();

    const [email, setEmail] = useState('')

    const [pass, setPass] = useState('')
    const [re_pass, setRePass] = useState('')

    const [token, setToken] = useState(null)

    const [otp, setOtp] = useState(null)

    const [show, setShow] = useState(true)
    const [curr_id, setCurrid] = useState(null)

    const [refill, setRefill] = useState(false)

    console.log('Token ', token)

    async function sendResetEmail(email) {
        let result = false;
        try {
            //await auth.signOut()
            result = await auth.sendPasswordResetEmail(email);
            console.log('Rsult ', result)
            toast('Password reset email sent. Please check your inbox.');
            setTimeout(() => {
                navigate(-1)
            }, 2000);
            return true;
        }
        catch (error) {
            console.error('Error sending reset email:', error);
            toast('Failed to send password reset email. Please try again.');
            return false;
        }
    }

    async function Sign_in() {

        if (email != '') {

            const room = db.ref('Sign_up')

            try {

                ///   let result = await auth.fetchSignInMethodsForEmail(email.toLocaleLowerCase())
                await auth.signInWithEmailAndPassword("n.joy@boomsoftware.co.uk", "2103199j")
                let result = await room.orderByChild('Email').equalTo(email.toLowerCase()).once('value')

                console.log('Result ', result.val())

                if (result != undefined && result.val() != null) {

                    await sendResetEmail(email.toLocaleLowerCase())

                }

                else {
                    toast('No user found with this email. Please sign up.');
                }
            }

            catch (e) {
                console.log('Error ', e)
                toast('An error occurred while processing your request. Please try again later.');
            }

        }


        else {

            toast('Empty fill are not accepted')
        }

    }

    const [width, setwidth] = useState(window.innerWidth);
    const [height, setWindowHeight] = useState(window.innerHeight);

    useEffect(() => {
        const windowSizeHandler = () => {
            setwidth(window.innerWidth)
            setWindowHeight(window.innerHeight)
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const isMobile = width <= 768;

    const [shown, setShown] = useState(false)

    function containsSpecialCharacter(str) {
        const specialCharsRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/;
        return specialCharsRegex.test(str);
    }


    const [first, setFirst] = useState(false)
    const [second, setSecond] = useState(false)
    const [third, setThird] = useState(false)
    const [four, setFour] = useState(false)
    const [fifth, setFifth] = useState(false)

    useEffect(() => {

        // numeric 
        if (pass.includes(0) || pass.includes(1) || pass.includes(2) || pass.includes(3) || pass.includes(4) || pass.includes(5) || pass.includes(6) || pass.includes(7) || pass.includes(8) || pass.includes(9)) {
            setFour(true)
        }
        else {
            setFour(false)
        }

        if ((hasLowerCase(pass))) {
            setThird(true)
        }
        else setThird(false)

        if ((hasUpperCase(pass))) {
            setSecond(true)
        }
        else setSecond(false)

        if (pass.length >= 7) {
            setFirst(true)
        }
        else setFirst(false)

        if ((containsSpecialCharacter(pass))) {
            setFifth(true)
        }
        else setFifth(false)


    }, [pass])

    function hasLowerCase(str) {
        return str.toUpperCase() != str;
    }

    function hasUpperCase(str) {
        return str.toLowerCase() != str;
    }

    return (
        !isMobile ? <div style={{ backgroundColor: '#080A0C', display: 'flex', flexDirection: 'row', width: width, height: height, alignItems: 'center', alignSelf: 'center', justifyContent: 'center' }}>
            <wc-toast></wc-toast>


            <div></div>

            <Button onClick={() => navigate('/Sign_up')} style={{ width: 190, height: 53, position: 'absolute', top: 30, right: 30, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 24, fontWeight: '700' }} >R</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 24, fontWeight: '700' }} >egister</Typography></Button>

            <div style={{ position: 'absolute', top: 35, right: 230, }}>
                <stripe-buy-button
                    buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                    publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                >
                </stripe-buy-button>
            </div>

            <div style={{ cursor: 'pointer', display: 'flex', position: 'absolute', top: 35, right: 230 }}>

            </div>


            <div style={{ backgroundColor: '#181E25', display: 'flex', width: 600, minHeight: 570, maxHeight: 885, alignSelf: 'center', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', borderRadius: 15 }}>
                <img src={require('../logo1.png')} style={{ height: 123, width: 242, marginTop: 40 }} />


                <input placeholder='Email' place style={{ marginTop: 50, borderRadius: 10, width: 475, backgroundColor: '#ECFEFD', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 22, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" value={email} onChange={(e) => setEmail(e.target.value)} />

                {refill && <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginTop: 20, width: 475, backgroundColor: '#ECFEFD', outline: 'none', height: 50, borderColor: '#26B8AD', borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: shown ? 0 : 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", borderTopRightRadius: 10, borderTopLeftRadius: 10, borderBottomLeftRadius: shown ? 0 : 10, borderBottomRightRadius: shown ? 0 : 10, }}>
                    <input onBlur={() => setShown(false)} onFocus={() => setShown(true)} placeholder='Reset Password' style={{ borderRadius: 10, width: 445, backgroundColor: '#ECFEFD', outline: 'none', height: 45, borderColor: '#26B8AD', borderWidth: 0, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type={show ? 'password' : 'text'} value={pass} onChange={(e) => setPass(e.target.value)} />
                    <div onClick={() => { setShow(!show) }} style={{ cursor: 'pointer', marginRight: 5 }}>{show ? <FaRegEyeSlash size={20} color='gray' /> : <FaRegEye size={20} color='gray' />}</div>
                </div>}

                <Collapsible open={shown} transitionTime={300}>
                    <div style={{ height: 155, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: 475, justifyContent: 'flex-start', paddingLeft: 15, borderBottomRightRadius: 10, borderBottomLeftRadius: 10, backgroundColor: '#ECFEFD', borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1, borderStyle: 'solid', color: '#A098AE' }}>



                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: first != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must be at least 7 charcters</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: second != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 upper case character</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: third != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1  lower case character</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: four != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 numeric character</text>


                        </div>

                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: fifth != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 special character</text>


                        </div>


                    </div>
                </Collapsible>


                {token && refill == false && <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginTop: 20, borderRadius: 10, width: 475, backgroundColor: '#ECFEFD', outline: 'none', height: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans" }}>
                    <input placeholder='Verification Code' style={{ borderRadius: 10, width: 445, backgroundColor: '#ECFEFD', outline: 'none', height: 45, borderColor: '#26B8AD', borderWidth: 0, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} value={otp} onChange={(e) => setOtp(e.target.value)} />
                    <div onClick={() => { setShow(!show) }} style={{ cursor: 'pointer', marginRight: 5 }}></div>
                </div>}

                <div style={{ width: 490, alignSelf: 'center', display: 'flex', marginTop: 10 }}>
                    <text onClick={() => navigate('/')} style={{ cursor: 'pointer', textAlign: 'left', fontSize: 22, fontWeight: '400', color: '#EDEDED', fontFamily: "Open Sans" }}>Back to login?</text>
                </div>


                {token == null && refill == false && <Button onClick={() => Sign_in()} style={{ width: 490, height: 53, marginTop: 35, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >S</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >end</Typography><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700', marginLeft: 10 }} >V</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 28, fontWeight: '700' }} >erification Link</Typography></Button>}

                <div style={{ height: 20, width: 200 }} />

            </div>

            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

        </div> : <div style={{ position: 'relative', backgroundColor: '#080A0C', display: 'flex', flexDirection: 'column', width: width, height: Math.max(height, 850), alignItems: 'center', alignSelf: 'center', justifyContent: 'center' }}>
            <wc-toast></wc-toast>

            <div></div>

            <div style={{ backgroundColor: '#181E25', display: 'flex', width: 380, height: 720, alignSelf: 'center', alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', borderRadius: 15 }}>

                <div style={{ display: 'flex', marginTop: 5 }}>
                    <stripe-buy-button
                        buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                        publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                    >
                    </stripe-buy-button>
                </div>

                <img src={require('../logo1.png')} style={{ height: 123, width: 242, marginTop: 15 }} />


                <input placeholder='Email' place style={{ marginTop: 50, borderRadius: 10, minWidth: 310, backgroundColor: '#ECFEFD', outline: 'none', minHeight: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontSize: 20, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type="text" value={email} onChange={(e) => setEmail(e.target.value)} />

                {refill && <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginTop: 20, minWidth: 310, backgroundColor: '#ECFEFD', outline: 'none', minHeight: 50, borderColor: '#26B8AD', alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", borderTopRightRadius: 10, borderTopLeftRadius: 10, borderBottomLeftRadius: shown ? 0 : 10, borderBottomRightRadius: shown ? 0 : 10, borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: shown ? 0 : 1 }}>
                    <input onBlur={() => setShown(false)} onFocus={() => setShown(true)} placeholder='Reset Password' style={{ borderRadius: 10, minWidth: 270, backgroundColor: '#ECFEFD', outline: 'none', minHeight: 42, borderColor: '#26B8AD', borderWidth: 0, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} type={show ? 'password' : 'text'} value={pass} onChange={(e) => setPass(e.target.value)} />
                    <div onClick={() => { setShow(!show) }} style={{ cursor: 'pointer', marginRight: 5 }}>{show ? <FaRegEyeSlash size={20} color='gray' /> : <FaRegEye size={20} color='gray' />}</div>
                </div>}

                <Collapsible open={shown} transitionTime={300}>
                    <div style={{ height: 155, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: 310, justifyContent: 'flex-start', paddingLeft: 15, borderBottomRightRadius: 10, borderBottomLeftRadius: 10, backgroundColor: '#ECFEFD', borderLeftWidth: 1, borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1, borderStyle: 'solid', borderColor: '#A098AE' }}>


                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: first != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must be at least 7 charcters</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: second != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 upper case character</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: third != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1  lower case character</text>


                        </div>
                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: four != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 numeric character</text>


                        </div>

                        <div style={{ height: '', display: 'flex', flexDirection: 'row', alignItems: 'center', width: 260, justifyContent: 'flex-start', marginTop: 5 }}>


                            <IoIosCheckmarkCircleOutline color='black' size={14} />
                            <text style={{ color: fifth != false ? 'black' : 'red', fontSize: 13, fontWeight: '400', fontFamily: "Open Sans", textAlign: 'left', marginLeft: 7 }}>Must have atleast 1 special character</text>


                        </div>


                    </div>
                </Collapsible>

                {token && refill == false && <div style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginTop: 20, borderRadius: 10, minWidth: 310, backgroundColor: '#ECFEFD', outline: 'none', minHeight: 50, borderColor: '#26B8AD', borderWidth: 1, alignSelf: 'center', borderStyle: 'solid', color: '#A098AE', fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans" }}>
                    <input placeholder='Verification Code' style={{ borderRadius: 10, minWidth: 290, backgroundColor: '#ECFEFD', outline: 'none', minHeight: 42, borderColor: '#26B8AD', borderWidth: 0, alignSelf: 'center', borderStyle: 'solid', color: 'black', fontSize: 20, fontWeight: 400, paddingLeft: 15, fontFamily: "Open Sans", }} value={otp} onChange={(e) => setOtp(e.target.value)} />
                    <div onClick={() => { setShow(!show) }} style={{ cursor: 'pointer', marginRight: 5 }}></div>
                </div>}


                <div style={{ width: 310, alignSelf: 'center', display: 'flex', marginTop: 10 }}>
                    <text onClick={() => navigate('/')} style={{ cursor: 'pointer', alignSelf: 'center', textAlign: 'left', fontSize: 22, fontWeight: '400', color: '#EDEDED', fontFamily: "Open Sans" }}>Back to login?</text>
                </div>


                {token == null && refill == false && <Button onClick={() => Sign_in()} style={{ width: 310, height: 53, marginTop: 35, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >S</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >end</Typography><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700', marginLeft: 10 }} >V</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 20, fontWeight: '700' }} >erification Link</Typography></Button>}

                <Button onClick={() => navigate('/Sign_up')} style={{ width: 310, height: 53, marginTop: 10, marginBottom: 5, borderWidth: 1, borderStyle: 'solid', borderColor: '#26B8AD', backgroundColor: '#F7941D', borderRadius: 10 }} ><Typography textTransform={'Upercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 24, fontWeight: '700' }} >R</Typography><Typography textTransform={'lowercase'} style={{ fontFamily: "Open Sans", color: '#000000', fontSize: 24, fontWeight: '700' }} >egister</Typography></Button>


            </div>

            <wc-toast></wc-toast>

            <text style={{ fontSize: 16, color: 'white', fontWeight: '600', position: 'absolute', bottom: 10, left: 10, letterSpacing: 1.01 }}>Version 1.7</text>

        </div>
    );
}

const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId })(Forget)
//export default Sign_in;

/*
 <div style={{ position: 'absolute', top: 35, right: 230, }}>
                    <stripe-buy-button
                        buy-button-id="buy_btn_1RO0KHGOVgfDdjwd10oaS68C"
                        publishable-key="pk_live_51HFkGVGOVgfDdjwdQowSBANlgyEuCLom3Lm7B4iCGtKFLXGfU9ezPScsLZNape1srePuSJ0S29nxgQsQ8X5Y2ZMV00txCVBJMu"
                    >
                    </stripe-buy-button>
                </div>

*/
